import { type ReactNode } from 'react'

import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'

import styles from './ClipboardGroupTitle.module.scss'

type Props = {
  children?: ReactNode
  count: number
  icon: IconType
  label: string
}

export const ClipboardGroupTitle = ({ children, count, icon, label }: Props) => (
  <h3 className={styles.container}>
    <IconWithLabel iconBefore={icon} iconBeforeSize='sm'>
      {label} <span className={styles.count}>({count})</span>
    </IconWithLabel>
    {children}
  </h3>
)
